import { ChangeDetectorRef, Component, ElementRef, Inject, Injectable, InjectionToken, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BehaviorSubject, Subject, Subscriber, Subscription } from 'rxjs';
import { HTTPService } from 'src/app/services/http.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { ButtonList } from '../actions-buttons/actions-buttons.component';
import { ArrayUtils } from '../utils/ArrayUtils';
import { ObjectUtil } from '../utils/ObjectUtil';
import * as ts from "typescript";
import { ThemeService } from 'src/app/services/theme.service';

export const VALIDATION = new InjectionToken<any>('');


@Component({
    selector: 'app-action-button-generic',
    templateUrl: './action-button-generic.component.html',
    styleUrls: ['./action-button-generic.component.scss'],
    standalone: false
})
export class ActionButtonGenericComponent implements OnInit {

  constructor(private http:HTTPService, private uid:UserAuthenticationServices, private cd:ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data, public dialogRef:MatDialogRef<any>,
    @Inject(VALIDATION) public validation:BehaviorSubject<String>,
    public ThemeService:ThemeService) { }

  dataResponse;
  tempArray:Object[] = [];
  localArray:Object[] = [];
  title:string = '';
  buttonList:ButtonList[] = [];
  sub:Subscription;
  sub2:Subscription;
  validationData;
  cols:Object[];
  isArray:boolean = false;
  colsCount:number = 0;
  expressao:string='';
  codecompany:string;
  codemktp:string;
  codecontract:string;
  arrayPath:string;
  actionButtonDataPath:string;
  showSearch:boolean = false;
  @Input()validation2;
  buttonListString:Object[] = [];
  currentComponent;
  offSet:any = 0;
  offSetFormula = null;
  @ViewChild('grid') private scrollContainer: ElementRef;
  showProgress:boolean = false;

  ngOnDestroy(){
      if( this.sub!=null){this.sub.unsubscribe();}
      if( this.sub2!=null){this.sub2.unsubscribe();}
  }

  updateFilter(evento){
      const filterValue = (evento.target as HTMLInputElement).value;

      if ( ObjectUtil.isNotEmpty(filterValue)){
        this.localArray = ArrayUtils.findValue(this.tempArray,filterValue);
      }else{
        this.localArray = this.tempArray;
      }
      
  }



  ngOnInit(): void {
      
      this.currentComponent  = this;
      
      
      this.sub2 = this.validation.subscribe(async data=>{
          
          this.validationData = data;
          //this.validationData = JSON.parse(data.toString());
          
          let returnType = this.validationData['returnType'];

          this.title = this.validationData['title'];
          this.cols = this.validationData['cols'];
          this.colsCount = this.validationData['colsCount'];
          this.expressao =this.validationData['formulaExpression'];
          this.codemktp = this.validationData['codemktp'];
          this.arrayPath = this.validationData['arrayPath'];
          this.actionButtonDataPath = this.validationData['actionButtonDataPath'];
          this.showSearch = this.validationData['showSearch'];
          this.buttonListString = this.validationData['buttonList'];
          this.offSetFormula = this.validationData['offSetFormula'];
          this.offSet = 0;

          if ( this.buttonListString != null ){
            this.buttonListString.forEach(data=>{
                this.buttonList.push({
                    description: data['description'],
                    color: data['color'],
                    icon: data['icon'],
                    action: (value)=> {
                      let code = ts.transpile("({Run: "+data['action']+"})");
                      let runnalbe :any = eval(code);
                      runnalbe.Run(this,ObjectUtil);
                    },
                })
            })
          }

          if ( returnType =='array'){
              this.isArray = true;
          }else{
            throw ('Não preparado para retorno de objeto.');
          }

          this.codecompany = (this.data as UntypedFormGroup).get("CODECOMPANY").value;
          this.codecontract = (this.data as UntypedFormGroup).get("CODECONTRACT").value;

          await this.executeServices();      
          
          if ( this.offSetFormula != null){
            let code = ts.transpile("({Run: "+this.offSetFormula+"})");
            let runnalbe :any = eval(code);
            runnalbe.Run(this,ObjectUtil);
            
            while ( this.offSet == true || this.offSet >0  ){     
                  await this.executeServices();
                  let code = ts.transpile("({Run: "+this.offSetFormula+"})");
                  let runnalbe :any = eval(code);
                  runnalbe.Run(this,ObjectUtil);
            }    
          }
      },error=>{
        throw error;
      });
      
  }

  gridTemplate():string{
      return 'repeat(' + this.colsCount + ', 1fr)';
  }

  /* coluna type=='edit': o template original referenciava uma variável inexistente; mantido como ponto de extensão */
  editarItem(data){
  }

  getData(data,path){
      let dados = ObjectUtil.FindObject(data,path);

      if ( dados ){
          
          return dados;
      }else{
          return "";
      }
  }

  getDataObject(data,path){
      let ob =  ObjectUtil.FindObject(data,path);
      let r ='';
      if ( ob instanceof Array){
        let d = ob[0];
        if ( d ){
          Object.keys(d).forEach(k=>{
            r = r+ k+': '+ d[k] + '<br/>'
          });
        }
      }

      return r;
  }

  selectLine(data){
    let value =  ObjectUtil.FindObject(data,this.actionButtonDataPath);

    if ( value ){
      if ( value instanceof Array){
        if ( value[0] == 0){
          this.dialogRef.close("0");  
        }else{
          this.dialogRef.close(value[0]);  
        }
      }else{
        if ( value instanceof String){
          
          this.dialogRef.close(value);
        }else{
          
          this.dialogRef.close(value[0]);
        }
        
      }
      
    }
  }

  executeServices(){

    return new Promise((resolve,reject)=>{
      //this.spinner.show('generic-action');
      this.showProgress = true;
    
      let arrayData:Object[] = [];
      let group:UntypedFormGroup =  this.data as UntypedFormGroup;
      Object.keys(group.controls).forEach(control=>{
        const abstractControl = group.controls[control];
        if ( abstractControl.value != null){
          arrayData.push({
            'key':'@'+control,
            'value':abstractControl.value instanceof Object ? abstractControl.value['id']  == null ? '' : abstractControl.value['id'] : abstractControl.value
          })
        }
      });
      
      arrayData.push({key:'@OFFSET', value:this.offSet})
      
      let ob = {
        "expressao": this.expressao,
        "novo": true,
        "codecompany": this.codecompany,
        "codemktp": this.codemktp != null ? this.codemktp : 0,
        "codecontract": this.codecontract,
        "values":arrayData 
      }
  
      
      this.sub = this.http.post(ob,'FormulaServices/test', true,true,false).subscribe(data=>{
          
          let resultado = data['resultado'];
          if ( resultado ){
            this.dataResponse = JSON.parse(resultado);
            let objectPath:Object[] = ObjectUtil.FindObject(this.dataResponse,this.arrayPath)[0];
            
            if ( objectPath?.length > 0){
              for (var obj of objectPath){
                this.localArray.push(obj);  
                this.tempArray.push(obj);  
              }
            }
          }
          this.showProgress = false;
          resolve(true);
      },error=>{
          //this.spinner.hide('generic-action');
          this.showProgress = false;
          throw error;
      },()=>{
          this.showProgress = false;
          //this.spinner.hide('generic-action');
      })
    
    });
    
  }

  
  scrollToBottom(): void {
    try {
        let lineSize = 40;
        let acount = lineSize * this.localArray.length;
        this.scrollContainer.nativeElement.scrollTop = acount; //this.scrollContainer.nativeElement.scrollHeight;
    } catch(err) { }                 
  }

  run(){
    
  }
}
